import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=bc19bdfa&"
import script from "./editForm.vue?vue&type=script&lang=js&"
export * from "./editForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editForm.vue"
export default component.exports